export default {
    mapper: {
        relations: {
            belongsToMany: {
                product: {
                    foreignKey: 'id',
                    localField: 'products',
                },
            },
        },
    },
};
